import { createStore } from "vuex";

import main from "./main/index.js";
import admin from "./admin/index.js";

// Create store instance once
let storeInstance = null;

function getStore() {
  if (!storeInstance) {
    storeInstance = createStore({
      modules: {
        main,
        admin,
      },

      // Strict mode installs a deep synchronous watcher over the entire store
      // that re-runs on every mutation to catch out-of-band state changes.
      // That traversal is very expensive at production data scale (dozens of
      // large Firestore-fed maps and class instances with expensive getters),
      // so keep it disabled.
      strict: false,
    });
  }
  return storeInstance;
}

// Export function for Quasar (returns store instance)
export default function (/* { ssrContext } */) {
  return getStore();
}

// Export store instance for direct imports in classes/utils
export const store = getStore();
